<template>
    <div >
            <div class="flex p-5-9 m-b9" >
<!--                <el-input-->
<!--                        style="width: 220px"-->
<!--                        size="mini"-->
<!--                        class="input"-->
<!--                        placeholder="输入识别码"-->
<!--                        v-model="vc_code"-->
<!--                        clearable-->
<!--                @change="searchFun">-->
<!--                </el-input>-->
                <span v-if="data.type=='add'">识别码</span>
                <el-select  class="inputwidth" size="mini" v-if="data.type=='add'" style="width:260px;" @change="searchFun" clearable filterable remote :remote-method="codesearch"  v-model="vc_code">
                    <el-option v-for="(val,index) in vcCodeList"  :label="val" :value="val"></el-option>
                </el-select>
                <span v-if="data.type=='bkadd'">补卡识别码</span>

                <el-select  class="inputwidth" size="mini" v-if="data.type=='bkadd'" style="width:260px;" @change="bksearchFun" clearable filterable remote :remote-method="bkcodesearch"  v-model="vc_bk_code">
                    <el-option v-for="(val,index) in vcBkCodeList"  :label="val" :value="val"></el-option>
                </el-select>
<!--                <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>-->

            </div>
        <div class=" m-b9">
                <el-table stripe ref="table" :header-cell-style="{background:'#f5f7fa',color:'#000'}" size="mini" :height="tableHeight" border  :data="tableData" style="width: initial;">
                    <!--            </el-table-column>-->
                    <el-table-column align="center" label="状态" prop="stateTxt" width="90">
                        <template class="flex"  slot-scope="scope">
                            <span :class="(scope.row.i_isconfirmed==-1||scope.row.i_isconfirmed==-2)?'red':(scope.row.i_isconfirmed==0)?'blue':'green'">{{scope.row.stateTxt}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="姓名" prop="userName" width="85" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="部门" prop="departmentName" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="类型" prop="overtimeType" width="140" show-overflow-tooltip>
                        <template  slot-scope="scope">
                            <span >{{scope.row.overtimeType==1?'薪资':'调休'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="开始时间" prop="startTime" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="结束时间" prop="endTime" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="时长" prop="overtimeHour"  width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="事由" prop="vc_reason"  show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="是否补卡" prop="i_isbk" width="90" show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <span>{{scope.row.i_isbk==1?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination  style="margin-top: 10px;text-align: right"
                                background
                                @current-change="pageCurrentChange"
                                layout="total,prev, pager, next"
                                :current-page.sync="currentPage"
                                :total="total"
                                :page-size="pageSize">
                </el-pagination>
        </div>
        <div  class="center">
            <el-button type="primary" @click="slFun" :disabled="!vc_code"  :class="baseerp+'btn'" size="small" v-if="data.type=='add'" >受理</el-button>
            <el-button type="primary" @click="bkslFun"  :class="baseerp+'btn'" size="small" v-if="data.type=='bkadd'" >受理补卡</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
<!--        <el-dialog title="校验其他时长"-->
<!--                   width="300"-->
<!--                   top="30px"-->
<!--                   :visible.sync="dialogYoN"-->
<!--                   :close-on-click-modal="false"-->
<!--                    append-to-body>-->
<!--            <el-button type="success" @click="saveOvertime(1)"  :class="baseerp+'btn'" size="small">同意</el-button>-->
<!--            <el-button type="danger" @click="saveOvertime(-1)" size="small">不同意</el-button>-->
<!--        </el-dialog>-->
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    import {mapActions} from "vuex";
    const getYm=()=>{
        let newD=new Date();
        let y=newD.getFullYear();
        let m=newD.getMonth()+1;
            m=m>9? m : '0'+m;
        return y+'-'+m
    };
    export default {

        name: "jiaBan",
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data(){
            return{
                baseerp:baseerp,
                vc_code:'',
                vc_bk_code:'',
                disabled:false,
                tableHeight:0,//列表高度
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                back:'back',
                dialogYoN:false,
                userId:0,
                vcCodeList:[],
                vcBkCodeList:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            });
            if(this.data.type=='code'){
                this.vc_code=this.data.data.vc_code
                this.userId=0
                this.overtimeList()
            }else if(this.data.type=='bkcode'){
                this.vc_code=this.data.data.vc_bk_code
                this.userId=0
                this.overtimeList()
            }else if(this.data.type=='name'){
                this.userId=this.data.data.userId
                this.vc_code=''
                this.overtimeList()

            }
            // console.log(this.data.type,'this.data.type')

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-200
            },
            slFun(){
                this.$confirm('审批完成,确认受理','提示',{
                    confirmButtonText:'确认',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.saveOvertime()

                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            bkslFun(){
                this.$confirm('审批完成,确认受理','提示',{
                    confirmButtonText:'确认',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.saveBkOvertime()

                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            codesearch(val){
                this.searchname=val
                this.listVcCode()
            },
            bkcodesearch(val){
                this.bksearchname=val
                this.listVcBkCode()
            },
            //名称搜索
            searchFun(val){
                this.currentPage=1
               this.overtimeList()
            },
            //名称搜索
            bksearchFun(val){
                this.currentPage=1
               this.overtimeList()
            },
            //名字选择

            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.overtimeList();

            },

            async saveOvertime() {

                let params = {
                    vc_code:this.vc_code,
                    i_state:1,
                };
                // console.log(params,'params')
                // return
                this.canSave=false
                this.canEdit=false
                let res = await API.approveOvertimeSq(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.back='save'
                    this.cancel()
                   // this.overtimeList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                    this.overtimeList()
                }
            },
            async saveBkOvertime() {

                let params = {
                    vc_bk_code:this.vc_bk_code,
                    i_state:1,
                };
                // console.log(params,'params')
                // return
                this.canSave=false
                this.canEdit=false
                let res = await API.approveOvertimeBk(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.back='save'
                    this.cancel()
                   // this.overtimeList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                    this.overtimeList()
                }
            },
            async overtimeList(){
                let param={
                    currentPage:this.currentPage,
                    pageSize: this.pageSize,
                    i_type:2,
                    vc_code:this.vc_code,
                    vc_bk_code:this.vc_bk_code,
                    userId:this.userId,

                };
                let res=await API.getOvertimeSqSubList(param);
                if(res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async listVcCode(){
                let param={
                    currentPage:this.currentPage,
                    pageSize: 50,
                    vc_search:this.searchname,

                };
                let res=await API.listVcCode(param);
                if(res.code==1){
                    this.vcCodeList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async listVcBkCode(){
                let param={
                    currentPage:this.currentPage,
                    pageSize: 50,
                    vc_search:this.bksearchname,

                };
                let res=await API.listVcBkCode(param);
                if(res.code==1){
                    this.vcBkCodeList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('close',this.back)
            },
       }
    }
</script>

<style lang="scss" scoped>
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .blue{
        color: dodgerblue;
    }
.p14{
    padding: 14px;
}
    .m-l14{
        margin-left: 14px;
    }
    .m-b9{
        margin-bottom: 9px;
    }
    .datetxt{
        font-size: 14px;
        display: inline-block;
        width: 50px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    /deep/{
        .el-radio{
            margin-right: 7px !important;
        }
    }
    .center{
        text-align: center;
    }
    .ghwdiv{
        .active{
            background-color: var(--opacityghw);
        }
        i{
            color: var(--darkghw);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .havaydiv{
        .active{
            background-color: var(--opacityhavay);
        }
        i{
            color: var(--darkhavay);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .fkbox{
        padding: 5px 9px;
        cursor: pointer;
    }
    .p-5-9{
        padding: 5px 9px;

    }
    .flex{
        display: flex;

    }
    div{
        /*font-size: 12px;*/
        line-height: 1.5;
    }
    /deep/{
        .el-dialog__title{
            color: #303133;
        }
        .el-dialog__close{
            color: #909399;
        }
    }
</style>